import React from 'react'

import { Wrapper, AlertIcon } from './pass-restriction-warning-v2.styles'

const PassRestrictionWarningV2 = ({
  message,
  showIcon = true,
  className,
}: {
  message: string
  showIcon?: boolean
  className?: string
}) => (
  <Wrapper className={className}>
    {showIcon && <AlertIcon />}
    {message}
  </Wrapper>
)

export default PassRestrictionWarningV2
